<template>
  <smd-select :value="value"
              @input="$emit('input',$event)"
              @open="$emit('open',$event)"
              @search-change="$emit('search-change', $event)"
              :hide-tags="hideTags"
              :hide-selected="hideSelected"
              :options="mutiSelectLookup"/>
</template>

<script>
  import {mapActions} from 'vuex'
  import {ACTION_REMOVE_CASE_MULTISELECT_ITEM} from '../../../store/forms/case-form-state'
  import {
    ObjectModelToArrayModel,
    injectCategoryIdToConditions,
    smdSelectModelReducer
  } from '../../../utilities/utilityOperators'
  import {getMapFn} from "../../../store/modules/referencedata2";

  export default {
    name: "smd-wrapped-select",
    props: {
      value                  : {type:Array,required: true},
      hideTags               : {type:Boolean, default: true},
      hideSelected           : {type:Boolean, default: true},
      multiSelectFormSection : null,
      multiSelectLookupName  : null,
      multiSelectConditionsLookupName : null,
      noDefaultMultiSelectLookup      : false
    },
    methods: {
      ...mapActions({
        doRemoveMultiSelectItem: ACTION_REMOVE_CASE_MULTISELECT_ITEM
      }),
      generateMultiSelectModel() {
        const raw = this.getRawModelForMultiSelect();
        const conditionsMapFn = this.getMultiSelectConditionsMapFn();
        return ObjectModelToArrayModel(raw, conditionsMapFn)
      },
      getMultiSelectConditionsMapFn() {
        return getMapFn(this.multiSelectConditionsLookupName);
      },
      getRawModelForMultiSelect() {
        return null;
      },
      removeMultiSelectItem(conditionId) {
        this.doRemoveMultiSelectItem({section: this.multiSelectFormSection, conditionId});
      },
      transformMultiSelectModel(v) {
        return v.reduce(smdSelectModelReducer, {});
      }
    },
    created() {
      if(!this.noDefaultMultiSelectLookup) {
        const mapFn = getMapFn(this.multiSelectLookupName);
        this.mutiSelectLookup = injectCategoryIdToConditions(mapFn)();
      }
    }
  }
</script>

<style scoped>

</style>